/**
 * Formats a Date object to ICS datetime format (YYYYMMDDTHHMMSSZ)
 * @param {Date} date - The date to format
 * @returns {string} - Formatted ICS datetime string
 */
const formatICSDate = (date) => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
};

/**
 * Generates and downloads an .ics calendar file for a QuickMeet meeting
 * @param {string} meetingId - The meeting ID
 * @param {Object} eventDetails - Event details object
 * @param {string} eventDetails.title - Event title
 * @param {Date} eventDetails.startTime - Event start time
 * @param {Date} eventDetails.endTime - Event end time
 * @param {string} eventDetails.description - Optional event description
 */
export const generateICS = (meetingId, eventDetails) => {
  const { title, startTime, endTime, description } = eventDetails;

  const meetingUrl = `${window.location.origin}/meet/${meetingId}`;
  const descriptionText = description
    ? `${description}\\n\\nJoin QuickMeet: ${meetingUrl}`
    : `Join QuickMeet: ${meetingUrl}`;

  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//QuickMeet//QuickMeet Video Conferencing//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
UID:${meetingId}@quickmeet.cam
DTSTAMP:${formatICSDate(new Date())}
DTSTART:${formatICSDate(startTime)}
DTEND:${formatICSDate(endTime)}
SUMMARY:${title}
DESCRIPTION:${descriptionText}
LOCATION:${meetingUrl}
STATUS:CONFIRMED
SEQUENCE:0
BEGIN:VALARM
TRIGGER:-PT10M
ACTION:DISPLAY
DESCRIPTION:Reminder: ${title} in 10 minutes
END:VALARM
END:VEVENT
END:VCALENDAR`;

  // Create blob and trigger download
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `quickmeet-${meetingId}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
